import script from "./BestsellersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BestsellersSection.vue?vue&type=script&setup=true&lang=js"

import "./BestsellersSection.vue?vue&type=style&index=0&id=27e93a97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e93a97"]])

export default __exports__